export const SHOW_TOAST = 'SHOW_TOAST'
export const setPublicCommDialogData = 'setPublicCommDialogData'
export const setOrderStoreInfo = 'setOrderStoreInfo'
export const setOpenPickTime = 'setOpenPickTime'
export const setPickTimeData = 'setPickTimeData'
export const setOrderRewardPointInfo = 'setOrderRewardPointInfo'
export const setOrderSettingTypeId = 'setOrderSettingTypeId'
export const setLineWebModeOn = 'setLineWebModeOn'
export const updateFilterStoreId = 'updateFilterStoreId'
export const updateStoreCode = 'updateStoreCode'